import React from 'react';
import _ from 'lodash';
import {Link} from 'react-router-dom';
import {Result} from 'antd';
import useTitle from '@/hook/useTitle';
import NewAppList from './NewAppList';
import {useCurrentUserAppsProfile, useMyApps} from './useHomeService';
import {toggleUserAppPined} from '@/api/apps';
import NewAppItem from './NewAppItem';
import AppDashItem from './AppDashItem';
import dayjs from 'dayjs';

export default function HomePage() {
    useTitle();

    const {enableReadApps, currentUserId} = useCurrentUserAppsProfile();

    // console.log('authStore......', authStore);
    const {loading, retry, value} = useMyApps(currentUserId, enableReadApps);

    // if (loading) {
    //     return <PageLoading />;
    // }
    const beginTime7 =
        dayjs(dayjs().subtract(7, 'days').format('YYYY-MM-DD') + ' 00:00:00').unix() * 1000;
    const endTime =
        dayjs(dayjs().subtract(0, 'days').format('YYYY-MM-DD') + ' 23:59:59').unix() * 1000;
    const beginTime1 =
        dayjs(dayjs().subtract(0, 'days').format('YYYY-MM-DD') + ' 00:00:00').unix() * 1000;
    let apps = _.get(value, 'data.apps', []);
    const meta = _.get(value, 'data.meta', {});
    let temp = [];
    // 进行app的排序
    apps.length > 0 &&
        apps.forEach((app, i) => {
            let {id} = app;
            if (_.isEmpty(meta)) {
                app.pined = false;
            } else {
                if (_.isEmpty(meta[`${id}`])) {
                    app.pined = false;
                } else {
                    const pined = meta[`${id}`].pined;
                    app.pined = pined;
                    pined && temp.push(app);
                }
            }
        });
    const newApps = apps.filter(item => !item.pined);
    apps = [...temp, ...newApps];
    // const pinedAppIds = Object.values(meta)
    //     .filter(({pined}) => pined)
    //     .sort((a, b) => b.modifyTime - a.modifyTime) // 按照 pined 时间倒序
    //     .map(({appId}) => appId);
    //
    // const pinedApps = pinedAppIds
    //     .map(appId => {
    //         return apps.find(({id}) => id === appId);
    //     })
    //     .filter(Boolean);

    function onPinedClick(appId, pined) {
        return e => {
            e.preventDefault();

            toggleUserAppPined(currentUserId, appId, !pined).then(data => {
                retry();
            });
        };
    }

    function renderAppList() {
        return (
            <>
                {/*{!_.isEmpty(pinedApps) && (*/}
                {/*    <AppList title="置顶应用" style={{marginBottom: 48}}>*/}
                {/*        {pinedApps.map(app => {*/}
                {/*            const {id, name, squareLogoUrl} = app;*/}
                {/*            return (*/}
                {/*                <Link key={id} to={`/apps/${id}`}>*/}
                {/*                    <AppItem*/}
                {/*                        appId={id}*/}
                {/*                        userId={currentUserId}*/}
                {/*                        title={name}*/}
                {/*                        imageUrl={squareLogoUrl}*/}
                {/*                        pined*/}
                {/*                        onPinedClick={onPinedClick(id, true)}*/}
                {/*                    />*/}
                {/*                </Link>*/}
                {/*            );*/}
                {/*        })}*/}
                {/*    </AppList>*/}
                {/*)}*/}

                <NewAppList title={'应用(' + apps.length + ')'}>
                    {apps.map((app, i) => {
                        const pined = _.get(meta, `${app.id}.pined`, false);
                        const {id, name, squareLogoUrl, description} = app;
                        console.log('..app', app);

                        return (
                            <Link key={id} to={`/apps/${id}`}>
                                <NewAppItem
                                    key={i}
                                    appId={id}
                                    userId={currentUserId}
                                    title={name}
                                    description={description}
                                    imageUrl={squareLogoUrl}
                                    pined={pined}
                                    onPinedClick={onPinedClick(id, pined)}
                                />
                            </Link>
                        );
                    })}
                </NewAppList>
                {apps.map((app, i) => (
                    <AppDashItem
                        title={app.name}
                        appId={app.id}
                        logo={app.squareLogoUrl}
                        endTime={endTime}
                        beginTime7={beginTime7}
                        beginTime1={beginTime1}
                        key={i}
                    />
                ))}
            </>
        );
    }

    return (
        <div style={{padding: 24, overflowY: 'auto'}}>
            {loading ? null : _.isEmpty(apps) ? (
                <Result
                    status="404"
                    title="您并非任何应用的成员"
                    subTitle="请联系管理员开通应用权限"
                    style={{marginTop: 100}}
                />
            ) : (
                renderAppList()
            )}
        </div>
    );
}
